import { UnitTest } from "../UnitTestClass";
import { DataProcessing } from "../DataprocClass";
import { SCHEMAS } from "../../constants";

export const validateTGSchema = (dataset) => {
  // 1. Check schema
  const tcValidations = new UnitTest(dataset);
  const checkSchema = tcValidations.checkSchema(SCHEMAS.tgSchema);
  return { checkSchema };
};

export const validateTGIntra = (dataset) => {
  const tcValidations = new UnitTest(dataset);
  // 1. Duplicates Test on QuotaComponent
  const duplicatesTest = tcValidations.checkDuplicates([
    "TerritoryGroupName",
    "BattlecardName",
  ]);
  const tgValidations = new UnitTest(dataset);
  const tgPreProcessing = new DataProcessing(dataset);
  //Prepare Data for DoesExistIn checks :
  // 1. Declare territoryGroup and parent column values as arrays
  const parentValuesInclNull =
    tgPreProcessing.extractValuesByProperty("Parent").column_data;
  const territoryGroupValues =
    tgPreProcessing.extractValuesByProperty("TerritoryGroupName").column_data;
  // 2. Remove Null values from Parent array in order to check against territoryGroup Array
  const parentValues = tgPreProcessing.filterArray(
    [null, "null", "", undefined],
    parentValuesInclNull
  );

  // 3. Check that All Non-Null Parent Values exist in the Battlecard array
  const existsInTestParent = tgValidations.checkExistsIn(
    parentValues,
    territoryGroupValues,
    "Parent"
  );

  return { duplicatesTest, existsInTestParent };
};
